import { render, html } from "lit-html";
import connect from "@escapio/shared/data-store/connect";
import { removeInitialContent } from "@escapio/shared/components/element-builder";
import { store } from "./DataStore";
import { PROFILE_STAGE_MOBILE } from "@escapio/shared/components/picture-sizes";
import "../PictureGallery";

customElements.define(
	"esc-stage",
	class extends connect(removeInitialContent(HTMLElement), store) {
		update({ selectedStagePicture }) {
			const template = html` <esc-picture-gallery
				class="stage__picture-gallery"
				sizes-key=${PROFILE_STAGE_MOBILE}
				enable-loader
				enable-counter
				force-load
				.pictures=${this.pictures}
				.currentPicture=${selectedStagePicture}
				track-category="Hotel"
				track-action-prefix="Bühne "
			></esc-picture-gallery>`;

			render(template, this);
		}

		get pictures() {
			return JSON.parse(this.getAttribute("pictures"));
		}
	},
);
